function getLineItemNotesContainer() {
  return document.querySelector('.line-item-notes');
}

function getLineItemNoteFields() {
  const container = getLineItemNotesContainer();
  if (!container) return [];
  return Array.from(container.querySelectorAll('input, select, textarea'));
}

function lineItemNotesAreVisible() {
  const container = getLineItemNotesContainer();
  return Boolean(container && container.classList.contains('visible'));
}

function getAddToCartForms() {
  return document.querySelectorAll('form[data-type="add-to-cart-form"]');
}

function noteFieldHiddenInputId(form, inputName) {
  return 'line-item-' + (form.id || 'form') + '-' + String(inputName).replace(/\s+/g, '-');
}

function syncNoteProperty(input) {
  const inputName = input.name;
  if (!inputName) return;

  const inputValue = input.value.trim();
  const notesVisible = lineItemNotesAreVisible();

  getAddToCartForms().forEach(function(form) {
    const hiddenInputId = noteFieldHiddenInputId(form, inputName);
    let hiddenInput = document.getElementById(hiddenInputId);

    if (notesVisible && inputValue) {
      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.id = hiddenInputId;
        hiddenInput.name = 'properties[' + inputName + ']';
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = inputValue;
    } else if (hiddenInput) {
      hiddenInput.remove();
    }
  });
}

function syncAllNoteProperties() {
  getLineItemNoteFields().forEach(syncNoteProperty);
}

function setNoteFieldsRequired(required) {
  getLineItemNoteFields().forEach(function(input) {
    if (required) {
      input.setAttribute('required', 'required');
    } else {
      input.removeAttribute('required');
      input.setCustomValidity('');
      input.classList.remove('is-invalid');
    }
  });
}

function lineItemNotesAreFilled() {
  if (!lineItemNotesAreVisible()) return true;

  return getLineItemNoteFields().every(function(input) {
    return input.value.trim() !== '';
  });
}

function validateLineItemNotes() {
  if (lineItemNotesAreFilled()) {
    getLineItemNoteFields().forEach(function(input) {
      input.classList.remove('is-invalid');
      input.setCustomValidity('');
    });
    return true;
  }

  let firstEmpty = null;
  getLineItemNoteFields().forEach(function(input) {
    const empty = input.value.trim() === '';
    input.classList.toggle('is-invalid', empty);
    input.setCustomValidity(empty ? 'This field is required' : '');
    if (empty && !firstEmpty) firstEmpty = input;
  });

  if (firstEmpty) {
    firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
    firstEmpty.focus();
    firstEmpty.reportValidity();
  }

  return false;
}

function handleInputChange(event) {
  const input = event.target;
  if (input.value.trim()) {
    input.classList.remove('is-invalid');
    input.setCustomValidity('');
  }
  syncNoteProperty(input);
}

function isCustomColorVariant(variant, colorOptionIndex) {
  if (!variant || !Array.isArray(variant.options)) return false;

  if (Number.isInteger(colorOptionIndex)) {
    const colorValue = String(variant.options[colorOptionIndex] || '').toLowerCase();
    return colorValue.includes('custom');
  }

  return variant.options.some(function(option) {
    return String(option).toLowerCase().includes('custom');
  });
}

function updateLineItemNotesVisibility(variant) {
  const lineNotesContainer = getLineItemNotesContainer();
  if (!lineNotesContainer) return;

  const rawIndex = lineNotesContainer.dataset.colorOptionIndex;
  const colorOptionIndex = rawIndex === '' || rawIndex == null ? NaN : parseInt(rawIndex, 10);

  const show = isCustomColorVariant(
    variant,
    Number.isNaN(colorOptionIndex) ? null : colorOptionIndex
  );

  lineNotesContainer.classList.toggle('visible', show);
  setNoteFieldsRequired(show);
  syncAllNoteProperties();
}

function handleVariantNotes(e) {
  updateLineItemNotesVisibility(e.detail && e.detail.variant);
}

function handleAddToCartSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;
  if (validateLineItemNotes()) return;

  event.preventDefault();
  event.stopImmediatePropagation();
}

document.addEventListener('product:variant-change', handleVariantNotes);
document.addEventListener('submit', handleAddToCartSubmit, true);

document.addEventListener('DOMContentLoaded', function() {
  const lineItemNotesContainer = getLineItemNotesContainer();
  if (!lineItemNotesContainer) return;

  getLineItemNoteFields().forEach(function(input) {
    input.addEventListener('input', handleInputChange);
    input.addEventListener('change', handleInputChange);
  });

  setNoteFieldsRequired(lineItemNotesAreVisible());
  syncAllNoteProperties();
});
